import './layout.scss';
import Vue from 'vue';
import VueTableOfContent from '@ui-common/vue-table-of-content';
import macc from '../../modules/MACC/macc';
import mhap from '../../modules/MHAP/mhap.vue';
import mjbl from '../../modules/MJBL/mjbl.vue';
import mstb from '../../modules/MSTB/mstb';
import mevp from '../../modules/MEVP/mevp';
import masd from '../../modules/MASD/masd.vue';
import starsFilter from '../../common/js/stars-filter/stars-filter';
import queryString from 'query-string';
import layoutBase from '../layout-base';

Vue.filter('stars', starsFilter);
Vue.component('macc', macc);
Vue.component('mhap', mhap);
Vue.component('mjbl', mjbl);
Vue.component('mstb', mstb);
Vue.component('mevp', mevp);
Vue.component('masd', masd);
Vue.component('vue-table-of-content', VueTableOfContent);

/* eslint-disable no-new*/
new Vue({
	extends: layoutBase,
	el: '[data-layout-id=APV9L-app]',
	data: {
		structureId: null
	},
	created() {
		let parsed = queryString.parse(location.search);
		this.structureId = parsed.structureId;
	}
});
/* eslint-enable*/
